<template>
  <div>
    <div style="height:60px" class="hidden-md-and-up"></div>
    <h2>REPOSICIÓN DE CREDENCIALES</h2>
    <v-layout row wrap>
      <v-flex lg7 md7 sm6 xs12 order-xs3 order-md2>
        <v-flex sm12>
            <v-card>
              <v-toolbar color="default" primary-title class="title font-weight-bold elevation-0">
                Búsqueda de Credenciales
              </v-toolbar>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-text-field label="Matricula Abogado" prepend-icon="search" v-model="matricula"
                        :disabled="consulta" :rules="requiredRules"></v-text-field>
                    </v-form>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-btn color="primary" @click.prevent="buscarCredenciales()" :loading="resultado" v-if="!consulta">
                      <v-icon>search</v-icon>Verificar
                      <span slot="loader" dark>
                        <v-progress-circular size="20" indeterminate color="white"></v-progress-circular>
                      </span>
                    </v-btn>
                    <v-btn icon color="error" flat v-else @click.prevent="limpiar()">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs12>
                    <div class="my-2">
                      <v-layout row wrap v-if="noData">
                        <v-alert class="flex lg12" type="error" :value="true">No se encuentra un Registro con la
                          Matricula
                          <strong>"{{ matricula }}"</strong>
                        </v-alert>
                      </v-layout>
                      <v-layout row wrap v-if="abogadoBusqueda != null">
                        <v-flex lg4 class="gray--text">Nombre Abogado:</v-flex>
                        <v-flex lg8>{{ abogadoBusqueda.nombres }} {{ abogadoBusqueda.primerApellido }}
                          {{ abogadoBusqueda.segundoApellido }}</v-flex>
                        <v-flex lg12>
                          <v-data-table :headers="headersBusqueda" :items="dessertsBusqueda"
                            :total-items="dessertsBusqueda.lenght" no-data-text="Abogado no registra Reposiciones"
                            hide-actions>
                            <template slot="items" slot-scope="props">
                              <td>{{ props.item.serie }}</td>
                              <td>{{ dateFormat(props.item.fechaActivacion) }}</td>
                              <td></td>
                              <td class="text-xs-left">
                                <v-btn small round
                                  :color="props.item.activo ? 'success' : 'error'">{{ props.item.activo ? 'VIGENTE' : 'INHABILITADO' }}</v-btn>
                              </td>
                            </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>

        <v-card>
          <v-toolbar color="default" primary-title class="title font-weight-bold elevation-0">
            Lista de Credenciales Anuladas - Gestion {{ new Date().getFullYear() }}
          </v-toolbar>

          <v-card-text>
            <v-data-table :headers="headers" :items="desserts" :pagination.sync="pagination"
              :total-items="totalDesserts" :rows-per-page-items="[10, 20]" rows-per-page-text="Cantidad Por Pagina"
              no-results-text="Sin resultados, no se encuentra ningun registro">
              <template slot="items" slot-scope="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.numeroDocumento }} {{ props.item.complementoDocumento }}</td>
                  <td class="text-xs-left">{{ props.item.serie }}</td>
                  <td class="text-xs-left">{{ dateFormat(props.item.fechaBaja) }}</td>
                </tr>
              </template>
              <template slot="no-data">No se registraron Credenciales anuladas para la gestión</template>
              <template slot="pageText" slot-scope="props">{{ props.pageStart }} - {{ props.pageStop }} de {{
              props.itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex lg5 md5 sm5 xs12 order-xs2 order-md1>
        <div id="panelResultados"></div>
        <v-layout row wrap>
          <v-flex lg12 sm12>
            <Requisito :requisitos="credencial.requisitos" :titulo="credencial.titulo" subheader="El abogado o abogada deberá:" />
          </v-flex>
          <v-flex lg12 sm12>
            <Requisito subheader="" :requisitos="credencial.notas" />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Requisito from "@/components/Registro/Requisito";
export default {
  components: {
    Requisito
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 10
      },
      totalDesserts: 0,
      valid: true,
      consulta: false,
      requiredRules: [
        v => !!v || "El campo no puede estar vacio",
        v => (v && v.length >= 10) || "El campo debe tener al menos 10 caracteres"
      ],
      matricula: null,
      numeroDocumento: null,
      resultado: false,
      noData: false,
      credenciales: null,
      headers: [
        {
          text: "Numero Documento",
          aligin: "left",
          sortable: false,
          activo: true
        },
        {
          text: "Serie",
          aligin: "left",
          sortable: false,
          activo: true
        },
        {
          text: "Fecha Anulacion",
          aligin: "left",
          sortable: false,
          activo: true
        }
      ],
      headersBusqueda: [

        {
          text: "Serie",
          aligin: "left",
          sortable: false,
          activo: true
        },

        {
          text: "Fecha Emision",
          aligin: "left",
          sortable: false,
          activo: true
        },
        {
          text: "Fecha Anulacion",
          aligin: "left",
          sortable: false,
          activo: true
        },
        {
          text: "Estado",
          aligin: "left",
          sortable: false,
          activo: true
        }
      ],
      dessertsBusqueda: [],
      abogadoBusqueda: null,
      credencial: {
        titulo: "Requisitos para Renovación y/o Reposición de la Credencial",
        requisitos: [
          {
            icon: "fingerprint",
            iconClass: "lime white--text",
            title: "1.	Tener habilitado su registro de Ciudadanía Digital, obtenido mediante los medios proporcionados por AGETIC.",
            subtitle:
              "<li>Sino cuentas con este registro, presiona aquí para registrarte <a href='https://www.gob.bo/ciudadania' class='blue--text' target='_blank' >www.gob.bo/ciudadania</a></li><li>AGETIC te brinda los pasos para registrarte como Ciudadano Digital: <a href='https://www.youtube.com/watch?v=f51EyLfXBy0&t=38s' target='_blank' >presiona aquí</a></li>",
          },
          {
            icon: "language",
            iconClass: "blue white--text",
            title: "2. Ingresar al Sistema de Registro de la Abogacía (SRA)",
            subtitle:
              "<li>Presiona aqui para ingresar <a href='https://sra.justicia.gob.bo' class='blue--text' target='_blank' >sra.justicia.gob.bo</a> ; acto seguido selecciona la opción <b>“Reposición y Renovación de la Credencial”</b></li><li>El Registro PúblIco de la Abogacía, te brinda los pasos para realizar la solicitud: <a href='https://www.youtube.com/watch?v=zjpYVbEnqFk' target='_blank'  >presiona aquí</a></li>",
          },
          {
            icon: "format_list_numbered",
            iconClass: "indigo white--text",
            title: "3. Completar los datos requeridos en el formulario de renovación o reposición:",
            subtitle:
              "<ul><li>Actualizar los Datos Personales.</li><li>Ingresar una Fotografía actualizada a <u><b>colores en fondo blanco</b>,  clara, de frente y sin lentes o sombrero</u> en formato JPG, no mayor a 1 MB.</li><li>Ingresar fotografía de su firma (bolígrafo de color azul ) estampada en un papel o fondo blanco, en formato JPG, no mayor a 1MB.</li></ul>"
          },
          {
            icon: "thumb_up",
            iconClass: "pink white--text ",
            title: "4.	Aprobar la solicitud de renovación o reposición de Credencial a través de Ciudadanía Digital.",
            subtitle: null
          },
          {
            icon: "monetization_on",
            iconClass: "green wite--textt",
            title: "5.	Elegir la modalidad de pago, Código de Pago de Trámites (CPT) vinculado sólo al Banco Unión S.A. o QR vinculado a cualquier Banco.",
            subtitle: null
          },

        ],
        notas: [
        {
            icon: "warning",
            iconClass: "yellow black--text",
            title: "¡Importante!",
          },

          {
            icon: "done_outline",
            subtitle:
              "El recojo de la credencial es personal o con Poder Notarial Específico"
          },
          {
            icon: "done_outline",
            subtitle:
              // "Las entregas de credenciales en oficinas se realizan en el siguiente plazo posterior al pago de la solicitud:<ul><li>La Paz, en 24 horas.</li><li>Santa Cruz, Cochabamba, Oruro, Potosí y Sucre en 48 horas.</li><li>Beni, Pando y Tarija en 72 horas.</li></ul>"
              "Realizado el pago, el proceso de renovación o reposición concluye y la entrega de la credencial física se realizará dentro de un plazo de 72 horas."
          },
        ]
      }
    };
  },
  computed: {
    desserts() {
      const credenciales = []
      const originales = [...this.$store.state.credenciales.map(i => Object.assign({}, i))];
      for (const credencial of originales) {
        const numeroDocumento = atob(credencial.numeroDocumento);
        credencial.numeroDocumento = numeroDocumento.split('').reverse().join('');
        credenciales.push(credencial)
      }
      return credenciales;
    }
  },
  mounted: function () {
    if (this.$vuetify.breakpoint.width > 960) {
      this.$vuetify.goTo(60);
    } else {
      this.$vuetify.goTo(0);
    }
  },
  methods: {
    buscarCredenciales() {
      if (this.$refs.form.validate()) {
        this.credenciales = null;
        this.noData = false;
        this.resultado = true;
        this.dessertsBusqueda = [];
        this.$vuetify.goTo("#panelResultados", {});
        this.$http
          .get(`${this.$apiUrl}publico/credencial`, {
            params: {
              matricula: this.matricula
            }
          })
          .then(response => {
            this.consulta = true;
            this.resultado = false;
            this.abogadoBusqueda = response.data.data.abogado;
            this.dessertsBusqueda = response.data.data.credenciales;
          })
          .catch(error => {
            this.consulta = true;
            this.resultado = false;
            this.noData = true;
            if (error.response) {
              if (error.response.status == 404) {
                this.$store.commit('setErrorColor', 'error')
                this.$store.commit(
                  "setError",
                  "Error en la peticion al servidor"
                );
              }
              if (error.response.status == 400) {
                this.$store.commit('setErrorColor', 'error')
                this.$store.commit(
                  "setError",
                  "Matricula no registrada en el RPA"
                );
              }
            }
          });
      }
    },
    limpiar() {
      this.consulta = false;
      this.noData = false;
      this.abogadoBusqueda = null;
      this.dessertsBusqueda = [];
    },
    dateFormat(date) {
      if (!date) return null;
      const [dates, hours] = date.split(" ");
      if (date.indexOf("-") > 0) {
        const [year, month, day] = dates.split("-");
        return `${day}/${month}/${year}`;
      }
      return date;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Credenciales/Credencial.vue